interface StackedBarIconProps {
	size?: number | string;
	color?: string;
}

export function StackedBarIcon({ size = 16, color }: StackedBarIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.8182 13.818L3.47643 13.818C3.1331 13.818 2.80382 13.6816 2.56105 13.4388C2.31827 13.1961 2.18188 12.8668 2.18188 12.5235L2.18188 2.18164M5.09098 5.09073L8.72734 5.09073M5.09098 7.99982H9.45461M5.09098 10.9089H5.81825M10.9092 5.09073H11.6364M11.6364 7.99982H13.091M8.00007 10.9089H10.1819"
				stroke={color || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
